import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchBrands,
  filterBrands,
  fetchMoreBrands,
  getFullList,
  fetchBrandByID,
  selectBrands,
} from "./brandsSlice";

import Grid from "@material-ui/core/Grid";
import BrandsList from "./BrandsList";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function BrandsContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [brandNames, setBrandNames] = useState([]);
  const [brandIDs, setBrandIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");

  const {
    brands,
    error,
    loading,
    brandsList,
    brandsFilter,
    brand,
    lastQuery,
    brandsAmount,
  } = useSelector(selectBrands);

  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const handleBrandsChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedBrand = brandsList.filter(
      (brand) => brand.name === event.target.value
    );
    selectedBrand && idsArr.push(selectedBrand[0].id);
    // });

    setBrandNames(event.target.value);
    setBrandIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchBrands({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > brandsList.length ? rowsPerPage : brandsList.length,
        query: searchQuery,
        targetLength: brandsAmount,
      })
    );
  };

  // useEffect(() => {
  //   if (loading !== "loading") {
  //     handleSearch();
  //   }
  // }, [brandIDs, supplierIDs, statusIDs, checked]);

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (brandsList.length < brandsAmount && brandsList.length < expectedLen) {
        dispatch(
          fetchMoreBrands({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (brandsList.length == brandsAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchBrands({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleEdit = (id) => {
    dispatch(
      fetchBrandByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchBrandByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleSearch = () => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    searchQuery = replaceUrlParam(searchQuery, "brands", brandIDs.join(","));

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchBrands({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setBrandNames([]);
    setBrandIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchBrands({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = ["status"];

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Brand #",
      long: true,
      sortable: true,
    },
    {
      id: "name",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Name",
      long: true,
      sortable: true,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      checked: true,
      long: true,
    },

    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      checked: true,
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      numeric: false,
      disablePadding: false,
      label: "Last Updated",
      checked: true,
      long: false,
      sortable: true,
    },
    {
      id: "statusID",
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Status",
      checked: true,
      long: false,
    },
  ];

  const [rowList, setRowList] = useState([...headCells]);

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <BrandsList
        brands={brands}
        handleBrandsChange={handleBrandsChange}
        brandNames={brandNames}
        brandIDs={brandIDs}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={brandsAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
